import { Dialog } from "@headlessui/react";
import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Transition } from "@headlessui/react";
import { Actions as ADVENTCALENDARACTIONS } from "../../store/actions/adventCalendarActions";

function TermsAndConditions({
	termsModalOpen,
	closeTermsModal,
}) {
	return (
		<Transition.Root
			show={termsModalOpen}
			as={Fragment}
		>
			<Dialog
				as="div"
				className="fixed z-50"
				onClose={() => {
					closeTermsModal();
				}}
			>
				<div className="fixed inset-0 z-50 w-screen overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 overflow-hidden">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>

						<span
							className="hidden sm:inline-block sm:align-middle sm:h-screen"
							aria-hidden="true"
						>
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
						<div className="inline-block align-bottom rounded-lg text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full min-w-full md:min-w-fit ">
							<div className="bg-gray-50 px-4 py-3">
								<div className="inline-block align-bottom rounded-lg text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full min-w-full md:min-w-fit ">
											<h1 className="text-8xl font-advent drop-shadow-xl text-black text-center">Terms</h1>
											<p>1. Introduction</p>
											<p>1.1. These Terms and Conditions ("Terms") govern your participation in the Buddy Advent Calendar Marketing Campaign (the "Campaign"). By participating in the Campaign, you agree to abide by these Terms.</p>
											<p>1.2. The Campaign is organized by Buddy, located at Level 2, OYIA Business Centre, Triq is-Salib tal-Marsa, Marsa, Malta.</p>
											<p>2. Eligibility.</p>
											<p>2.1. To participate in the Campaign, you must be 16 years old or older and have agreed to receive marketing emails from our sponsors.</p>
											<p>3. Campaign Details</p>
											<p>3.1. The Campaign involves an interactive marketing promotion where participants can open an "advent calendar gift box" each day leading up Christmas. Upon opening a gift box, participants may be required to engage in various activities, such as watching a video, answering a question, or performing other interactive actions as specified by the campaign.</p>
											<p>3.1.1 Gift Box Activities:</p>
											<p>Video Viewing: In some instances, participants may need to watch a video related to the campaign's charitable cause before opening a gift box. The video content may provide valuable information that the participant can use in their daily life.</p>
											<p>Questionnaire: Certain gift boxes may contain interactive questionnaires or quizzes designed to educate participants and ensure active engagement.</p>
											<p>3.1.2 Gift Box Contents:</p>
											<p>Charitable Contribution: Upon successfully completing the required activity and opening a gift box, participants will discover a gift or item symbolizing a specific charitable contribution. The value of the contribution associated with each gift box will be detailed within the campaign.</p>
											<p>3.1.2.1. Product Placements:</p>
											<p>Please note that some gift boxes may include product placements by advertisers. These product placements are intended to enhance the overall experience of the Campaign and may include information about products or services offered by our advertising partners.</p>
											<p>All advertisers will be contributing directly to the Foodbank and Buddy shall make no profit from introducing advertisers into the campaign.</p>
											<p>3.2 Charitable Donation by Buddy:</p>
											<p>At the conclusion of the Campaign, Buddy will make a charitable donation to a designated food bank or charitable organization. The total donation amount will be based on the cumulative participation of all campaign participants and the associated gifts revealed. A maximum cap of 2% of revenue shall be in place.</p>
											<p>Independent auditors will verify that any such donation was not lower than the value of gifts donated or 2% of revenue, should this be exceeded.</p>
											<p>Expenses relating to running and launching this campaign are not part of the 2% charitable donation.</p>
											<p>3.3 Transparency and Reporting:</p>
											<p>Buddy is committed to transparency regarding the charitable donations. Regular updates and reports will be provided to participants and the public to demonstrate the impact of the Campaign and the distribution of funds to the designated food bank.</p>
											<p>Participants are encouraged to actively engage in the Campaign by opening gift boxes, watching videos, answering questions, and sharing their experiences to maximize the charitable contribution to the food bank.</p>
											<p>4. Additional Contributions</p>
											<p>4.1. Buddy may allow other businesses or individuals to contribute additional funds to increase the impact of the Campaign.</p>
											<p>4.2. Any additional contributions received will be used exclusively for charitable purposes in alignment with the Campaign's goals.</p>
											<p>5. Marketing Consent</p>
											<p>5.1. By participating in the Campaign, you agree to receive marketing emails from our sponsors.</p>
											<p>5.2. You understand and consent to the fact that the advertisers involved in the Campaign may change throughout the advent calendar. A list of contributors to the campaign will be kept updated, each advertiser is individually responsible for managing your data responsibly in-line with GDPR.</p>
											<p>6. Data Protection and GDPR</p>
											<p>6.1. Buddy will collect and process your personal data in accordance with applicable data protection laws, including the General Data Protection Regulation (GDPR).</p>
											<p>6.2. Your personal data will be used for the purposes of administering the Campaign and communicating with you. Please refer to our Privacy Policy for more information on how your data will be handled.</p>
											<p>7. Disclaimer</p>
											<p>7.1. Buddy reserves the right to modify, suspend, or terminate the Campaign at any time without prior notice.</p>
											<p>7.2. Buddy is not responsible for any technical issues, interruptions, or errors that may occur during the Campaign.</p>
											<p>8. Governing Law and Jurisdiction</p>
											<p>8.1. These Terms shall be governed by and construed in accordance with the laws of Malta, and any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Malta.</p>
											<p>9. Contact Information</p>
											<p>9.1. If you have any questions or concerns about the Campaign or these Terms, please contact us at adventcalendar@buddy.hr.</p>
										</div>
								</div>
							</div>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
	</Transition.Root>
	);
}

const mapStateToProps = (state) => {
	return {
		termsModalOpen: state.adventCalendar.termsModal || false,

	};
};

const mapDispatchToProps = (dispatch) => ({
	closeTermsModal: () => dispatch(ADVENTCALENDARACTIONS.getTermsModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);